import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSidebarInbox = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M15.875 21.75h-8.15c-3.21 0-5.37-2.25-5.37-5.6V8.47c0-3.35 2.16-5.6 5.37-5.6h5.33c.41 0 .75.34.75.75s-.34.75-.75.75h-5.33c-2.35 0-3.87 1.61-3.87 4.1v7.68c0 2.49 1.52 4.1 3.87 4.1h8.15c2.35 0 3.87-1.61 3.87-4.1v-5.8c0-.41.34-.75.75-.75s.75.34.75.75v5.8c0 3.35-2.16 5.6-5.37 5.6"
    />
    <path
      fill="currentColor"
      d="M18.575 8.39c-1.69 0-3.07-1.38-3.07-3.07s1.38-3.07 3.07-3.07 3.07 1.38 3.07 3.07-1.38 3.07-3.07 3.07m0-4.64c-.86 0-1.57.7-1.57 1.57s.7 1.57 1.57 1.57 1.57-.7 1.57-1.57-.7-1.57-1.57-1.57M11.805 16.32c-1.37 0-2.59-.76-3.2-1.99-.25-.51-.78-.84-1.35-.84h-4.13c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4.13c1.15 0 2.18.64 2.69 1.68.35.71 1.06 1.15 1.86 1.15s1.5-.44 1.86-1.15a2.99 2.99 0 0 1 2.69-1.68h4.14c.41 0 .75.34.75.75s-.34.75-.75.75h-4.14c-.57 0-1.1.33-1.35.84a3.56 3.56 0 0 1-3.2 1.99"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSidebarInbox);
export default ForwardRef;
